import { Detect } from "../internal/Detect"

/** `document`, or `undefined` where the environment has none (absent in workers and node). */
export const GetDocument = (): Document | undefined => Detect("document")
